import {SMOKING_SESSION_ENTITY_TYPE} from './session-store.js';
import {SMOKING_ITEM_ENTITY_TYPE} from './item-store.js';
import {SMOKING_STAGE_ENTITY_TYPE} from './stage-store.js';
import {
  STAGE_ITEM_TARGET_ENTITY_TYPE,
  STAGE_TARGET_ENTITY_TYPE
} from './stage-target-store.js';
import {SESSION_WOOD_ENTITY_TYPE} from './wood-mix-store.js';
import {ITEM_PREPARATION_ENTITY_TYPE} from './preparation-store.js';
import {CUSTOM_PRODUCT_ENTITY_TYPE} from './custom-product-store.js';
import {journalNoteEntityType,JournalNoteScope} from './journal-note.js';
import {TEMPERATURE_READING_ENTITY_TYPE} from '../live/temperature-reading-store.js';
import {LIVE_EVENT_ENTITY_TYPE} from '../live/live-event-store.js';
import {LIVE_STAGE_TRANSITION_ENTITY_TYPE} from '../live/stage-transition-store.js';
import {LIVE_NOTE_ENTITY_TYPE} from '../live/live-note-store.js';

export const JOURNAL_SESSION_NOTE_ENTITY_TYPE=journalNoteEntityType(JournalNoteScope.SESSION);
export const JOURNAL_ITEM_NOTE_ENTITY_TYPE=journalNoteEntityType(JournalNoteScope.ITEM);

export const JOURNAL_LOCAL_ENTITY_TYPES=Object.freeze([
  SMOKING_SESSION_ENTITY_TYPE,
  CUSTOM_PRODUCT_ENTITY_TYPE,
  SMOKING_ITEM_ENTITY_TYPE,
  SMOKING_STAGE_ENTITY_TYPE,
  STAGE_TARGET_ENTITY_TYPE,
  STAGE_ITEM_TARGET_ENTITY_TYPE,
  SESSION_WOOD_ENTITY_TYPE,
  ITEM_PREPARATION_ENTITY_TYPE,
  JOURNAL_SESSION_NOTE_ENTITY_TYPE,
  JOURNAL_ITEM_NOTE_ENTITY_TYPE,
  TEMPERATURE_READING_ENTITY_TYPE,
  LIVE_EVENT_ENTITY_TYPE,
  LIVE_NOTE_ENTITY_TYPE,
  LIVE_STAGE_TRANSITION_ENTITY_TYPE
]);

export const JOURNAL_SYNC_PRIORITY=Object.freeze({
  [SMOKING_SESSION_ENTITY_TYPE]:10,
  [CUSTOM_PRODUCT_ENTITY_TYPE]:15,
  [SMOKING_ITEM_ENTITY_TYPE]:20,
  [SMOKING_STAGE_ENTITY_TYPE]:20,
  [SESSION_WOOD_ENTITY_TYPE]:25,
  [JOURNAL_SESSION_NOTE_ENTITY_TYPE]:30,
  [ITEM_PREPARATION_ENTITY_TYPE]:40,
  [JOURNAL_ITEM_NOTE_ENTITY_TYPE]:40,
  [STAGE_TARGET_ENTITY_TYPE]:40,
  [STAGE_ITEM_TARGET_ENTITY_TYPE]:50,
  [TEMPERATURE_READING_ENTITY_TYPE]:60,
  [LIVE_EVENT_ENTITY_TYPE]:70,
  [LIVE_NOTE_ENTITY_TYPE]:75,
  [LIVE_STAGE_TRANSITION_ENTITY_TYPE]:80
});

export function isJournalLocalEntityType(value){
  return JOURNAL_LOCAL_ENTITY_TYPES.includes(String(value||''));
}

export function journalSyncPriority(entityType){
  return JOURNAL_SYNC_PRIORITY[String(entityType||'')]??100;
}

export function createJournalOfflineInspector({repository,queue,userId}={}){
  if(!repository?.list)throw new TypeError('repository with list is required');
  if(!queue?.listPending)throw new TypeError('sync queue is required');
  const owner=String(userId||'').trim();
  if(!owner)throw new TypeError('userId is required');

  async function snapshot(){
    const result={};
    for(const type of JOURNAL_LOCAL_ENTITY_TYPES){
      const rows=await repository.list(type);
      result[type]=Object.freeze((rows||[]).filter(row=>row.userId===owner));
    }
    return Object.freeze(result);
  }

  async function pendingSummary(){
    const pending=await queue.listPending();
    const result={};
    for(const type of JOURNAL_LOCAL_ENTITY_TYPES)result[type]=0;
    for(const row of pending||[]){
      if(isJournalLocalEntityType(row.entityType)&&row.userId===owner){
        result[row.entityType]=(result[row.entityType]||0)+1;
      }
    }
    return Object.freeze(result);
  }

  async function conflicts(){
    const snapshotRows=await snapshot();
    const rows=[];
    for(const type of JOURNAL_LOCAL_ENTITY_TYPES){
      for(const row of snapshotRows[type]||[]){
        if(row.syncStatus==='conflict'){
          rows.push(Object.freeze({
            entityType:type,
            id:row.id,
            sessionId:type===SMOKING_SESSION_ENTITY_TYPE
              ?row.id
              :(row.sessionId||null),
            eventType:row.eventType||null,
            fromStageId:row.fromStageId||null,
            toStageId:row.toStageId||null,
            stageMutationBatchId:row.stageMutationBatchId||row.mutationBatchId||null,
            conflict:row.conflict||null
          }));
        }
      }
    }
    return Object.freeze(rows);
  }

  return Object.freeze({snapshot,pendingSummary,conflicts});
}
